import { DEFAULT_NAMESPACE } from '@backstage/catalog-model';
import { createRouteRef } from '@backstage/core-plugin-api';
import { getOrCreateGlobalSingleton } from '@backstage/version-bridge';

const entityRouteRef = getOrCreateGlobalSingleton(
  "catalog:entity-route-ref",
  () => createRouteRef({
    id: "catalog:entity",
    params: ["namespace", "kind", "name"]
  })
);
function entityRouteParams(entity) {
  var _a, _b;
  return {
    kind: entity.kind.toLocaleLowerCase("en-US"),
    namespace: (_b = (_a = entity.metadata.namespace) == null ? void 0 : _a.toLocaleLowerCase("en-US")) != null ? _b : DEFAULT_NAMESPACE,
    name: entity.metadata.name
  };
}

export { entityRouteParams, entityRouteRef };
//# sourceMappingURL=routes.esm.js.map
